import { GroupItemBaseModel } from '../../group';
import { ItemBaseModel } from '../../item-base.model';
import { InputItemModel } from './input-item.model';

export interface InputListModel extends GroupItemBaseModel {
  type: 'list';
  name: string;
  label?: string;
  addItemLabel?: string;
  items: InputItemModel[];
}

export const isInputListItem = (item: ItemBaseModel): item is InputListModel => {
  return item.type === 'list';
};
